
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { login, signup, logout } from '../../actions/session_actions';

import { forgotPassword } from '../../actions/user_actions';

import ForgotPassword from './forgot_password';

const mapStateToProps = (state, ownProps) => {

  const loggedIn = Boolean(state.session.currentUser)
  let currentUser = loggedIn ? state.session.currentUser : null;
  let errors = state.errors.session;

  return {
    currentUser,
    loggedIn,
    errors,
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  signup: user => dispatch(signup(user)),
  login: user => dispatch(login(user)),
  forgotPassword: data => dispatch(forgotPassword(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));
